import useAuthContext from './useAuthContext';
import { useMutation } from '@apollo/client';
import { MUTATION_CREATE_TASK, MUTATION_SIGN_IN } from '../api/mutations';
import { QUERY_GET_TASKS } from '../api/queries';

export const useCreateTaskMutation = (): Array<any> => {
  const [createTaskMutation, results] = useMutation(MUTATION_CREATE_TASK, {
    refetchQueries: [{ query: QUERY_GET_TASKS }],
  });

  const createTask = (data: any) => {
    const { title, description, tags } = data;
    return createTaskMutation({
      variables: {
        data: {
          title,
          description,
          tags,
        },
      },
    });
  };

  return [createTask, results];
};
